<template>
<b-container fluid>
  <b-alert :show="showAlert" fade dismissible :variant="variant" @dismissed="showAlert=false">{{$t(message)}}</b-alert>
  <ModalConfirmDeletePickupPoint ref="modalDeletePickupPoint" :pickupPoint="pickupPointSelected" @showMessage="handleShowMessage"/>
  <HeaderPickupPoints @filterTable="handleFilterTable" @showAll="handleFilterTable"/>
  <ListPickupPoints :filters="filters" :refreshTable="refreshTable" @showConfirmDeleteModal="showModal"/>
</b-container>
</template>

<script>
import ModalConfirmDeletePickupPoint from './ModalConfirmDeletePickupPoint'
import HeaderPickupPoints from './HeaderPickupPoints.vue'
import ListPickupPoints from './ListPickupPoints.vue'
export default {
  components: {
    ModalConfirmDeletePickupPoint,
    HeaderPickupPoints,
    ListPickupPoints
  },
  data () {
    return {
      filters: {},
      pickupPointSelected: {},
      message: '',
      variant: 'success',
      showAlert: false,
      refreshTable: false
    }
  },
  methods: {
    handleFilterTable (filters) {
      this.filters = {...filters}
      this.refreshTable = !this.refreshTable
    },
    showModal (data) {
      this.pickupPointSelected = data
      this.$refs.modalDeletePickupPoint.showConfirmModal()
    },
    handleShowMessage (data) {
      this.showAlert = true
      this.message = data.message
      this.variant = data.variant
       this.refreshTable = !this.refreshTable
    }
  }
}
</script>

<style>

</style>